module.exports = __webpack_public_path__ + "static/media/BAL.96793241.svg";